export const DefaultColors = [
    '#E71F1A',
    '#EC078D',
    '#FAEE00',
    '#F39800',
    '#924F9B',
    '#4A459A',
    '#1A499D',
    '#62B0E3',
    '#6BB82E',
    '#1C923B',
    '#B28247',
    '#00A29A',
    '#231916',
    '#595857',
    '#B5B5B6',
    '#FFFFFF',
];


export const DefaultPanelColors = [
    '#E71F1A',
    '#FAEE00',
    '#00761a',
    '#0000ff',
    '#000000'
];

export const DefaultPanelBackgroundColors = [
    '#FAEE00',
    '#EC078D',
    '#00761a',
    '#0000ff',
    '#F39800',
    '#ffffff'
];